// import '../utils/event';
import Vue from 'vue'
import axios from 'axios'
import {API_URL, DEFAULT_LANG_UUID} from '../utils/consts'
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
import {validateEmail} from "./validators/emailValidator";
import {validateCompanyVatId} from "./validators/companyVatIdValidator";
import {validateTelephone} from "./validators/telephoneValidator";
import {accountExistsValidator} from "./validators/accountExistsValidator";
import VueMask from 'v-mask'
import {cloneDeep, sortBy} from 'lodash'

Vue.filter('lang', (value, lang) => {
  return value && value[lang || DEFAULT_LANG_UUID]
})
Vue.use(VueMask, {
  placeholders: {
    '#': null,
    D: /\d/,
    Я: /[\wа-яА-Я]/,
  }
})
import Toasted from 'vue-toasted'
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)
import { VueMaskFilter } from 'v-mask'
Vue.filter('VMask', VueMaskFilter)
import VueForm from 'vue-form';
import {validatePersonalIdentificationNumber} from './validators/validatePersonalIdentificationNumber'
import {validateCompanyId} from './validators/validateCompanyId'
import DocumentService from '../MyAccount/components/Monetization/DocumentService';

Vue.use(VueForm, {
  validators: {
    company_id: value => validateCompanyId(value),
    vat_id: value => validateCompanyVatId(value),
    email: value => validateEmail(value),
    phone: value => validateTelephone(value),
    matches: (value, attrValue) => {
      if (!attrValue) {
        return true
      }
      return value === attrValue;
    },
    personal_id: value => validatePersonalIdentificationNumber(value.replace('\/', '')),
    personal_id_exists: async value => {
      let isValid = validatePersonalIdentificationNumber(value.replace('\/', ''))
      if (isValid) {
        const registered = await accountExistsValidator(value.replace('\/', ''))
        return !registered
      }
      return true
    },
    company_id_exists: async value => {
      let isValid = validateCompanyId(value)
      if (isValid) {
        const registered = await accountExistsValidator(value.replace('\/', ''))
        return !registered
      }
      return true
    },
    password_min_length: value => value?.length >= 12,
    password_upper_case: value => /(?=.*[A-Z])/.test(value), 
    password_lower_case: value => /(?=.*[a-z])/.test(value), 
    password_contain_number: value => /(?=.*\d)/.test(value),
    password_special_character: value => /(?=.*\W)/.test(value)
  }
});
Vue.use(Toasted)

new Vue({
  el: '#registration',

  data() {
    return {
      translates: {},
      types: ['individual', 'legal', 'propertyOfSpouses', 'shared'],
      error: null,
      success: null,
      activeStep: 1,
      citiesPending: false,
      countriesPending: false,
      companyPending: false,
      language: null,

      cities: [],
      countries: [],
      company: null,

      state: {},

      form: {
        agree: false,
        type: 'individual',
        newsletter: false,
        personalIdentificationNumber: null,
        companyId: null,
        name: null,
        surname: null,
        street: null,
        streetNumber: null,
        city: null,
        zip: null,
        country: null,
        password: null,
        password2: null,
        titleBefore: null,
        titleAfter: null,
        contactPerson: {
          name: null,
          email: null,
          phone: '+420'
        },
        bankAccount: {
          accountNumber: null,
          bankCode: null,
          swift: null,
          iban: null,
        },
        husband: {
          personalIdentificationNumber: null,
          name: null,
          surname: null,
          street: null,
          streetNumber: null,
          city: null,
          zip: null,
          country: null,
          titleBefore: null,
          titleAfter: null,
          companyId: null,
          mailingAddress: {
            used: false,
            street: null,
            streetNumber: null,
            city: null,
            zip: null,
          },
          addresses: []
        },
        wife: {
          personalIdentificationNumber: null,
          name: null,
          surname: null,
          street: null,
          streetNumber: null,
          city: null,
          zip: null,
          country: null,
          titleBefore: null,
          titleAfter: null,
          companyId: null,
          mailingAddress: {
            used: false,
            street: null,
            streetNumber: null,
            city: null,
            zip: null,
          },
          addresses: []
        },
        mailingAddress: {
          used: false,
          street: null,
          streetNumber: null,
          city: null,
          zip: null,
        },
        addresses: [],
        dataBox: null
      }
    }
  },

  async created() {
    this.translates = JSON.parse(document.getElementById('registration-translates').innerHTML)
    await Promise.all([this.findCountries(), this.findCities()])
    this.fetchCore()
  },

  methods: {
    async onSubmit(event) {
      if (this.state.$invalid) {
        return;
      }

      this.error = null
      this.success = null

      this.form.contactPerson.name = `${this.form.name} ${this.form.surname}`

      let form = cloneDeep({...this.form})
      delete form.password2
      delete form.agree

      if (this.form.type !== 'propertyOfSpouses') {
        delete form.husband
        delete form.wife
      }

      if (this.form.type === 'legal' && this.form.country?.code !== 'CZE') {
        form = {...form, ...this.company}
      }

      form.country = form.country?.id || null
      form.city = form.city || null
      form.zip = form.zip ? form.zip.replace(/\s/g, '') : null
      form.companyId = form.companyId || null
      form.personalIdentificationNumber = form.personalIdentificationNumber ? form.personalIdentificationNumber.replace('\/', '') : null

      if (this.form.type === 'propertyOfSpouses') {
        form.husband.zip = form.husband.zip ? form.husband.zip.replace(/\s/g, '') : null
        form.wife.zip = form.wife.zip ? form.wife.zip.replace(/\s/g, '') : null

        form.husband.country = this.form.husband.country?.id || null
        form.husband.city = this.form.husband.city || null
        form.wife.country = this.form.wife.country ?.id || null
        form.wife.city = this.form.wife.city || null
        form.wife.companyId = form.wife.companyId || null
        form.husband.companyId = form.husband.companyId || null


        form.husband.personalIdentificationNumber = form.husband.personalIdentificationNumber ? form.husband.personalIdentificationNumber.replace('\/', '') : null
        form.wife.personalIdentificationNumber = form.wife.personalIdentificationNumber ? form.wife.personalIdentificationNumber.replace('\/', '') : null   
        
        form.husband.addresses.push({
          type: 'residence',
          country: form.husband.country,
          street: form.husband.street,
          streetNumber: form.husband.streetNumber,
          city: form.husband.city,
          zip: form.husband.zip
        })

        if (form.husband.used) {
          const mailingAddress = {
            type: 'mailing',
            country: form.husband.country,
            ...form.husband.mailingAddress
          }
          delete mailingAddress.used
          form.husband.addresses.push(mailingAddress)
        }

        form.wife.addresses.push({
          type: 'residence',
          country: form.wife.country,
          street: form.wife.street,
          streetNumber: form.wife.streetNumber,
          city: form.wife.city,
          zip: form.wife.zip
        })

        if (form.wife.mailingAddress.used) {
          const mailingAddress = {
            type: 'mailing',
            country: form.wife.country,
            ...form.wife.mailingAddress
          }
          delete mailingAddress.used
          form.wife.addresses.push(mailingAddress)
        }
        
        delete form.titleBefore
        delete form.titleAfter
        delete form.country
        delete form.husband.mailingAddress
        delete form.wife.mailingAddress
      }

      if (this.form.type === 'legal') {
        delete form.titleBefore
        delete form.titleAfter
      }

      if (this.form.type !== 'legal' && this.form.type !== 'individual') {
        delete form.companyId
      }

      if (this.form.type === 'individual') {
        if (form.mailingAddress.used) {
          const mailingAddress = {
            type: 'mailing',
            country: form.country,
            ...form.mailingAddress,
          }
          delete mailingAddress.used
          form.addresses.push(mailingAddress)
        }
        
      } else {
        if (this.form.country?.code === 'CZE') {
          delete form.personalIdentificationNumber
          delete form.name
          delete form.surname
          delete form.street
          delete form.streetNumber
          delete form.city
          delete form.zip
        } else {
          delete form.personalIdentificationNumber
          delete form.name
          delete form.surname
        }
        delete form.addresses
        delete form.dataBox
      }

      delete form.mailingAddress
      delete form.residenceAddress

      try {
        const {data} = await axios.post(`${API_URL}/account`, form, {headers: {'content-type': 'application/json'}})
        this.activeStep = 2
        this.success = data.record
        window.scrollTo(0,200)
        this.setHead()
      } catch (e) {
        const msg = e.response.data.errors ? e.response.data.errors.message : 'Registraci nelze provést, nejsou vyplněny povinné položky.'
        this.error = msg
        this.$toasted.show(msg, {type: 'error', duration: 10000})
        window.scrollTo(0, 200)
      }
    },

    setHead() {
      try {
        const el = JSON.parse(document.getElementById('head-step2').innerHTML)
        document.title = el.title
        document.querySelector('meta[name="description"]').setAttribute('content', el.description)
        document.querySelector('meta[name="keywords"]').setAttribute('content', el.keywords)
        console.log('head changed', el)
      } catch (e) {
        console.error(e)
        console.error('head not changed')
      }

    },

    async findCities(query) {
      this.citiesPending = true
      try {
        const {data: {records: cities}} = await axios.post(`${API_URL}/city/search`, {page: 0, perPage: 30, term: query || ' '}, {headers: {'content-type': 'application/json'}})
        this.cities = cities
      } catch (e) {
        console.error(e)
      }
      this.citiesPending = false
    },

    async findCountries() {
      this.countriesPending = true
      try {
        const {data: {records: countries}} = await axios.get(`${API_URL}/country/search`, {headers: {'content-type': 'application/json'}})
        this.countries = countries.map(c => {
          return {...c, localizedName: c.name[DEFAULT_LANG_UUID]}
        })
        this.countries = sortBy(this.countries, 'localizedName')
      } catch (e) {
        console.error(e)
      }
      this.countriesPending = false
    },

    async fetchCompany() {
      this.company = null
      this.companyPending = true
      try {
        const {data: {record: company}} = await axios.get(`${API_URL}/account/company?companyId=${this.form.companyId}`, {headers: {'content-type': 'application/json'}})
        this.company = company
      } catch (e) {
        console.error(e)
        this.$toasted.show(`Litujeme, ale společnost se zadaným IČ ${this.form.companyId} se nám nepodařilo dohledat. Vyplňte prosím údaje ručně.`, {type: 'error', duration: 6000})
      }
      this.companyPending = false
    },

    async fetchCore() {
      const {data: {language, country: countryUuid}} = await axios.get(`${API_URL}/core`, {headers: {'content-type': 'application/json'}})
      this.language = language
      const country = this.countries.find(i => i.id === countryUuid)
      if (country) {
        this.form.country = country
        this.form.husband.country = country
        this.form.wife.country = country
      }
    },

    async print() {
      try {
        const {data, headers} = await DocumentService.generateDocument('pdf', 'prohlaseni-zajemce', null, {id: this.success.husband ? this.success.husband.id : this.success.id})
        const a = document.createElement('a');
        const fileName = headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')
        a.href = URL.createObjectURL(data);
        a.download = fileName
        a.click();
      } catch (e) {
        console.log(e)
      }
    },

    countryChanged() {
      if (this.form.country?.code !== 'CZE') {
        this.company = {
          company: '',
          street: '',
          streetNumber: '',
          zip: '',
          city: ''
        }
      } else {
        this.company = null;
      }
    }
  }
});
